export interface ENV {
  API_KEY_ENDPOINT: string;
  API_ENDPOINT: string;
  ACCOUNT_ENDPOINT: string;
  MEDIA_ENDPOINT: string;
  CHAT_ENDPOINT: string;
  SIGNALR_ENDPOINT: string;
  FIREBASE_FCM_VAPID_KEY: string;
  OPENAI_API_KEY: string;
  N8N_BACKEND_ENDPOINT: string;
}

export const envConfig: ENV = {
  API_KEY_ENDPOINT: process.env.REACT_APP_APIKEY_ENDPOINT ?? "",
  API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT ?? "",
  ACCOUNT_ENDPOINT: process.env.REACT_APP_ACCOUNT_API_ENDPOINT ?? "",
  MEDIA_ENDPOINT: process.env.REACT_APP_MEDIA_API_ENDPOINT ?? "",
  CHAT_ENDPOINT: process.env.REACT_APP_CHAT_API_ENDPOINT ?? "",
  SIGNALR_ENDPOINT: process.env.REACT_APP_SIGNALR_ENDPOINT ?? "",
  FIREBASE_FCM_VAPID_KEY: process.env.REACT_APP_FIREBASE_FCM_VAPID_KEY ?? "",
  OPENAI_API_KEY: process.env.OPENAI_API_KEY ?? "",
  N8N_BACKEND_ENDPOINT: process.env.REACT_APP_N8N_BACKEND_ENDPOINT ?? "https://n8n.mikotech.online"
};
